const STORAGE_KEY = 'svp:newPlayer';

export const isNewPlayerEnabled = (): boolean => {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
        return false;
    }
};
